import { Component } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../layout/auth-page-layout/auth-page-layout.component';
import { ForgotPasswordForm } from '../../../components/auth/forgot-password-form/forgot-password-form';

@Component({
  selector: 'app-forgot-password',
  imports: [
    AuthPageLayoutComponent,
    ForgotPasswordForm,
  ],
  templateUrl: './forgot-password.html',
})
export class ForgotPassword {

}
